import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import InventoryStore from 'src/app_deprecated/stores/InventoryStore';

import { inventoryAtom } from 'src/app/state/inventory';

import { QueryBuilderMultiSelect } from './query-builder-multiselect';

type StrainDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type Strain = {
  id: number;
  name: string;
};

export function StrainDropdown({ onChange, values, disabled = false }: StrainDropdownProps) {
  const [loading, setLoading] = useState(false);
  const { strains } = useRecoilValue(inventoryAtom);

  const transformedStrains: Strain[] = (strains || []).map((strain) => ({
    id: strain.StrainId,
    name: strain.StrainName,
  }));

  async function handleRefresh() {
    setLoading(true);
    await InventoryStore.refreshStrains();
    setLoading(false);
  }

  return (
    <QueryBuilderMultiSelect<Strain>
      automationIdPrefix='strain'
      defaultLabel='Select a strain'
      disabled={disabled}
      idKey='id'
      items={transformedStrains}
      loading={loading}
      nameKey='name'
      refreshData={handleRefresh}
      values={values}
      onChange={onChange}
    />
  );
}
